/**
 * This file concerned visual behaviour of add-to-cart-variation template.
 * Eg: Bullets selector.
 */

(function (TIPTOE, w, d, $) {
  const $form = $('.wc-variation-form');
  let variantIsLoaded = false;
  const $document = $(document);
  const $selects = $('.select-variation__select');
  const incrementVariationQuantityElements = document.querySelectorAll(
    '.js-increment-variation-quantity',
  );
  const handleBulletsNavElements = document.querySelectorAll('.js-handle-bullets-nav');
  const handleBulletClickElements = document.querySelectorAll('.js-handle-bullet-click');
  let isSelect2Init = false;
  let priceElement = document.querySelector('.woocommerce-variation-price .price');

  let iconFlickity = null;

  /**
   *
   */
  function AddToCartVariationVisualBehaviour() {
    this.handleSelect2 = this.handleSelect2.bind(null, TIPTOE.IS_MOBILE_MENU);
  }

  AddToCartVariationVisualBehaviour.prototype.init = function () {
    window.addEventListener('load', this.handleTHWEPOBehaviour);
    window.addEventListener('load', this.handleZoom);
    window.addEventListener('load', this.handleSelect2);
    window.addEventListener('load', this.checkBulletsNavVisibility);

    $(w).on('resizeEnd', this.handleSelect2);
    $(w).on('resizeEnd', this.checkBulletsNavVisibility);

    $form.on('woocommerce_update_variation_values', this.hideUnavailableBullets);
    $form.on('woocommerce_update_variation_values', this.updateAvailability);
    $form.on('woocommerce_update_variation_values', this.checkBulletsNavVisibility);
    $selects.on('change', this.handleSelectChange);

    $form.on('show_variation', function () {
      if (variantIsLoaded) return;

      variantIsLoaded = true;
      const items = window.view_item_data;
      items[0].id_variation = document.querySelector('[name="variation_id"]').value;
      const attributes_name = document.querySelectorAll('.attribute__name');
      const attributes = [];
      attributes_name.forEach(function (element) {
        attributes.push(element.innerHTML);
      });
      items[0].item_variant = attributes.join(', ');

      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          items,
        },
      });
    });

    if (incrementVariationQuantityElements.length > 0) {
      for (const incrementVariationQuantityElement of incrementVariationQuantityElements) {
        incrementVariationQuantityElement.addEventListener(
          'click',
          this.handleIncrementVariationQuantity,
        );
      }
    }

    if (handleBulletsNavElements.length > 0) {
      for (const handleBulletsNavElement of handleBulletsNavElements) {
        handleBulletsNavElement.addEventListener('click', this.handleBulletsNavigation);
      }
    }

    if (handleBulletClickElements.length > 0) {
      for (const handleBulletClickElement of handleBulletClickElements) {
        handleBulletClickElement.addEventListener('click', this.handleBulletClick);
      }
    }

    if ($('.drag-origin__area--bullet--icon').length) {
      if ($('.attr-config').length <= 4 && !TIPTOE.IS_MOBILE) {
        return;
      }

      if (TIPTOE.IS_MOBILE && $('.attr-config').length <= 3) {
        return;
      }

      const defaultsOptions = {
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        groupCells: true,
        cellAlign: 'left',
      };

      iconFlickity = $('.drag-origin__area--bullet--icon').flickity(defaultsOptions);

      $('.attr-config').on('click', function () {
        iconFlickity.flickity('selectCell', $(this).index(), false, false);
      });
    }
  };

  /**
   * Check if bullets navigation should be visible
   * @returns {void}
   */
  AddToCartVariationVisualBehaviour.prototype.checkBulletsNavVisibility = function () {
    const bulletAreas = document.querySelectorAll('.drag-origin__area--bullet');

    bulletAreas.forEach(function (bulletArea) {
      const bulletAreaWidth = bulletArea.offsetWidth;
      const navButtons = bulletArea.parentNode.querySelectorAll('.js-handle-bullets-nav');
      console.log(bulletAreaWidth);

      let totalChildrenWidth = 0;
      const children = bulletArea.children;

      for (let i = 0; i < children.length; i++) {
        if (
          !children[i].classList.contains('drag-origin__container--hidden') &&
          i < children.length - 1
        ) {
          totalChildrenWidth += children[i].offsetWidth + 20;
        } else if (!children[i].classList.contains('drag-origin__container--hidden')) {
          totalChildrenWidth += 0;
        }
      }

      console.log(totalChildrenWidth);

      if (totalChildrenWidth <= bulletAreaWidth) {
        navButtons.forEach(function (button) {
          button.style.display = 'none';
        });
      } else {
        navButtons.forEach(function (button) {
          button.style.display = '';
        });
      }
    });
  };

  /**
   * Handle THWEPO extra cost start.
   * @returns {void}
   */
  AddToCartVariationVisualBehaviour.prototype.handleTHWEPOExtraCost = function (event) {
    event.currentTarget.classList.add('form-is-not-loaded');

    if (!priceElement) {
      return;
    }

    priceElement.classList.add('price--hidden');
  };

  /**
   * Handle THWEPO extra cost finished.
   * @param {object} Price data.
   * @returns {void}
   */
  AddToCartVariationVisualBehaviour.prototype.handleTHWEPOExtraCostFinished = function (event) {
    // DOM change so we need to refetch DOM Node on each AJAX request.
    priceElement = document.querySelector('.woocommerce-variation-price .price');

    event.currentTarget.classList.remove('form-is-not-loaded');

    if (priceElement) {
      priceElement.classList.remove('price--hidden');
    }
  };

  /**
   * Handle THWEPO plugin behaviour.
   * @returns {void}
   */
  AddToCartVariationVisualBehaviour.prototype.handleTHWEPOBehaviour = function () {
    if (typeof window.thwepo_public === 'undefined') {
      return;
    }

    window.thwepo_public.initialize_thwepo();

    const THWEPOaction = 'thwepo_calculate_extra_cost';

    if (!$form.length) {
      return;
    }

    /*
      THWEPO plugin don't trigger JavaScript events after add extra cost, so we use `$.ajax()` middleware to do it.
     */
    $form.on('thwepo_calculate_extra_cost', this.handleTHWEPOExtraCost);
    $form.on('thwepo_calculate_extra_cost_finished', this.handleTHWEPOExtraCostFinished);

    $document.ajaxSend(function (event, xhr, settings) {
      const { data } = settings;

      if (!data || !data.includes(`action=${THWEPOaction}`)) {
        return;
      }

      $form.trigger('thwepo_calculate_extra_cost');
    });

    $document.ajaxComplete(function (event, xhr, settings) {
      const { data } = settings;

      if (!data || !data.includes(`action=${THWEPOaction}`)) {
        return;
      }

      const priceData = xhr.responseJSON.price_data ? xhr.responseJSON.price_data : false;

      $form.trigger('thwepo_calculate_extra_cost_finished', priceData);
    });
  };

  AddToCartVariationVisualBehaviour.prototype.handleZoom = function () {
    const $img = $('.product__figure');

    if ($img.length === 0) {
      return;
    }

    $img.zoom({ url: $img.data('zoom') });
  };

  AddToCartVariationVisualBehaviour.prototype.handleSelectChange = function () {
    const $select = $(this);

    const $wrapper = $select.parents('.select-variation').siblings('.drag-origin');

    if ($wrapper.length === 0 || $wrapper.hasClass('is-first-attribute')) {
      return;
    }

    const $items = $wrapper.find('.js-handle-bullet-click');

    if ($items.length === 0) {
      return;
    }

    $items.removeClass('is-active');

    const $item = $items.filter(`[data-value="${$select.val()}"]`);
    const $attributeName = $wrapper.parents('.attributes__loop').find('.attribute__name');

    if ($attributeName.length > 0) {
      $attributeName.html($item.parent().data('text'));
    }

    $item.addClass('is-active');
  };

  AddToCartVariationVisualBehaviour.prototype.handleSelect2 = function (isMobile) {
    if (!$selects) {
      return;
    }

    if (isMobile === true) {
      if (!isSelect2Init) {
        return;
      }

      $selects.select2('destroy');
      isSelect2Init = false;
      return;
    }

    $selects.select2();
  };

  AddToCartVariationVisualBehaviour.prototype.updateAvailability = function () {
    const $form = $('form.variations_form');
    const $availability = $('.availability-variation');

    if (!$form.length || !$availability.length) return;
    $form.on('found_variation', function (event, variation) {
      if (variation) {
        const $attributeMore = $availability.find('.attribute__more');
        const textContent = variation.text_field;

        if (textContent && textContent.trim() !== '') {
          $availability.show();

          $attributeMore
            .removeClass()
            .addClass(`attribute__more attribute__more--${variation.text_field_color}`);

          $attributeMore.find('span').html(textContent).css('color', variation.text_field_color);
        } else {
          $availability.hide();
        }
      }
    });

    $form.on('reset_data', function () {
      $availability
        .find('.attribute__more')
        .removeClass()
        .addClass('attribute__more')
        .find('span')
        .html('')
        .css('color', '');

      $availability.hide();
    });
  };
  AddToCartVariationVisualBehaviour.prototype.hideUnavailableBullets = function () {
    const $wrappers = $selects.parents('.variations').find('.drag-origin');

    const $items = $wrappers.find('.js-handle-bullet-click');

    const items = [];
    for (const $item_ of $items) {
      const $item = $($item_);
      const $parent = $item.parents('.drag-origin__container');

      items[$item.data('value')] = $parent;

      $parent.addClass('drag-origin__container--hidden');
    }

    const $options = $selects.find('option');
    for (const { value } of $options) {
      if (items[value] === undefined) {
        continue;
      }

      items[value].removeClass('drag-origin__container--hidden');
    }

    $wrappers.find('.drag-origin__area--bullet').css({
      height: 'auto',
      overflow: 'initial',
    });

    if (iconFlickity && typeof iconFlickity.flickity === 'function') {
      iconFlickity.flickity('resize');
    }

    setTimeout(function () {
      AddToCartVariationVisualBehaviour.prototype.checkBulletsNavVisibility();
    }, 100);
  };

  AddToCartVariationVisualBehaviour.prototype.handleIncrementVariationQuantity = function (event) {
    const { quantity } = event.currentTarget.dataset;
    const $target = $(event.currentTarget);
    const $input = $target.parents('.results__control').find('.qty');

    if ($('.woocommerce-variation-add-to-cart-disabled').length > 0) {
      return;
    }

    if ($input.length === 0) {
      return;
    }

    const newQuantity = Number.parseInt($input.val(), 10) + Number.parseInt(quantity, 10);

    if (
      newQuantity < Number.parseInt($input.attr('min'), 10) ||
      newQuantity > Number.parseInt($input.attr('max'), 10)
    ) {
      return;
    }

    $input.val(newQuantity).trigger('change').trigger('input');

    $input[0].dispatchEvent(new Event('input'));
  };

  AddToCartVariationVisualBehaviour.prototype.handleBulletClick = function (event) {
    const attributeSlug = event.currentTarget.dataset.value;
    const $target = $(event.currentTarget);
    const $parent = $target.parents('.attributes__loop');

    if ($parent.length === 0) {
      return;
    }

    const $select = $parent.find('.select-variation > .select-variation__select');

    if ($select.length === 0) {
      return;
    }

    $parent.find('.drag__bullets').removeClass('is-active');

    const $attributeName = $parent.find('.attribute__name');

    if ($attributeName.length > 0) {
      $attributeName.html($target.parent().data('text'));
    }

    $target.addClass('is-active');

    $target.parents('.drag-origin').trigger('bullet_change', [attributeSlug]);

    $select.val(attributeSlug).trigger('change');
  };

  AddToCartVariationVisualBehaviour.prototype.handleBulletsNavigation = function (event) {
    const { direction } = event.currentTarget.dataset;
    const $target = $(event.currentTarget);

    if (direction === 'prev') {
      $target.addClass('is-hidden');
      $target.siblings('.drag__nav--next').removeClass('is-hidden');
      window.TweenLite.to($target.siblings('.drag-origin__area'), 0.4, {
        x: '0%',
      });
    }

    if (direction === 'next') {
      $target.addClass('is-hidden');
      $target.siblings('.drag__nav--prev').removeClass('is-hidden');
      window.TweenLite.to($target.siblings('.drag-origin__area'), 0.4, {
        x: '-50%',
      });
    }
  };

  $(document).ready(function () {
    const component = new AddToCartVariationVisualBehaviour();
    component.init();
  });
})(TIPTOE, window, document, jQuery);
